import { BaseRequest } from '@/network/requests/BaseRequest';
import { user_rights_group } from '@/interfaces/user_rights_group';

export const userRightsGroupRequest = BaseRequest.build<user_rights_group>('user_rights_group');